import { HttpErrorResponse } from '@angular/common/http';

export function isHttpErrorResponse(error: Error): error is HttpErrorResponse {
  return error?.name == 'HttpErrorResponse';
}

export function getFirstErrorFromResponse(error: Error): string | null {
  if (!isHttpErrorResponse(error)) return null;
  else if (error.status == 404)
    return 'The resource no longer exists and may have been deleted';
  else if (typeof error.error?.detail === 'string' && error.error.detail.trim())
    return error.error.detail;
  else if (!error.error?.errors) return null;
  const values = Object.values(error.error.errors);
  return values?.length && (<Array<string>>values[0])[0].length
    ? (<Array<string>>values[0])[0]
    : null;
}

export const ErrorType = {
  Action:
    'There was an error when attempting this action, please refresh the page and try again.  If it persists, please contact 3xLogic support via your dealer.',
  GenericAlert:
    'There was an error when attempting this action, please try again.',
};
